import * as screenActions from '../../Common/actions/Screen';
import * as fieldActions from './Field';
import * as condActions from './Cond';

export function initFunctions(funcs) {
    if (funcs) {
        screenActions.initFunctions(funcs);
        fieldActions.initFunctions(funcs);
        condActions.initFunctions(funcs);
    }
}

export function createNewContainer(screen, title) {
    const field = screen.collection.createNewField({name: screen.nextId, container: 0}, screen);
    screen.collection.addField(field);
    field.initContainerField({
        title: title,
        isOrOp: true,
        message: '',
        engmessage: '',
        active: true,
        isNewContainer: true,
        conds: []
    });
    screenActions.selectField(field);
}

export function updateScreen(screen, data) {
    screen.updateScreen(data);
}

export const containersScreenActions = {
    initFunctions,
    updateScreen
};
